import { ProjectLinked } from '@frontend/sorghum/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { PROJECT_LINKED } from '../apis';

async function getProjectLinked(id: string): Promise<ProjectLinked | null> {
  return (
    axios
      .get(`${PROJECT_LINKED}/${id}`)
      .then((res) => res.data.data)
      // 這支是 IG/Threads 專案入口頁的請求，全域 queryClient 開了 useErrorBoundary，
      // 沒接錯誤的話後端一擋（如方案 guard 回 491）整頁會炸成「找不到頁面」，
      // 客戶連升級入口都看不到（2026-07 已達上限客訴）。失敗時回 null 顯示未連接狀態。
      .catch(() => null)
  );
}

export function useProjectLinked(id?: string) {
  const { projectID } = useParams();

  return useQuery<ProjectLinked | null>({
    queryKey: ['project-linked'],
    queryFn: () => {
      if (projectID) {
        return getProjectLinked(projectID);
      } else {
        return null;
      }
    },
  });
}

export default useProjectLinked;
